import { quoteLineType } from '../../types'
import { TdSynnexSftpItemV2 } from './tdSynnexTypes'

export function tdSynnexItemToLineItem(
  lineNumber: number,
  mfgPN: string,
  item: TdSynnexSftpItemV2,
): Partial<quoteLineType> {
  return {
    LineItemId: crypto.randomUUID(),
    LineNumber: lineNumber,
    Bundle: null,
    Provider: 'TD SYNNEX Corp.',
    Manufacturer: item.manufacturer,
    MfrPartNumber: mfgPN,
    VendorPartNumber: item.synnexSKU,
    Description: item.shortDescription,
    Qty: 1,
    UnitCost: item.unitCostWithoutPromo,
    MSRP: item.msrp,
    TAA: item.taaCompliant,
    CountryOfOrigin: item.govClass?.coo ?? item.cooList,
    EnergyStar: item.govClass?.energyStar ?? null,
    EPEAT: item.govClass?.epeatLevel ?? null,
    UPC: item.upcCode,
    UNSPSC: item.unspscCode,
  }
}
